import { render, staticRenderFns } from "./push-type.vue?vue&type=template&id=e6fbc0ec&scoped=true&"
import script from "./push-type.vue?vue&type=script&lang=js&"
export * from "./push-type.vue?vue&type=script&lang=js&"
import style0 from "./push-type.vue?vue&type=style&index=0&id=e6fbc0ec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6fbc0ec",
  null
  
)

export default component.exports